module.exports = __webpack_public_path__ + "img/ts1.b17c756b.png";